import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'modules/api/utils';
import { UrlNames } from 'modules/app/constants';
import { configService } from 'modules/app/services';

import type { MagicLinkParams } from './types';

const API_VERSION = 'v1';

const getBaseURL = () => `${configService.getUrl(UrlNames.AuthApi)}/${API_VERSION}`;

export const authenticationApi = createApi({
  reducerPath: 'authenticationApi',
  baseQuery: axiosBaseQuery({ baseURL: getBaseURL }),
  endpoints: (builder) => ({
    requestMagicLink: builder.mutation<void, MagicLinkParams>({
      query: (data) => ({
        url: '/auth/magic-link',
        method: 'POST',
        // Opt every magic-link request into the scanner-safe interstitial wrap (NAT-669). The
        // auth-api's server-side `interstitialDefault` stays false; the frontend enables the
        // feature here, at the request level, by always sending `useInterstitial: true`.
        data: { ...data, useInterstitial: true },
        // Send credentials so the browser stores the cross-subdomain `flow_id` cookie set by
        // the auth-api response. That cookie binds the magic link to this browser and enables
        // the interstitial's silent-redirect path. Without it the cookie is dropped and users
        // fall back to the explicit "Continue" page. Safe: the auth-api returns
        // `Access-Control-Allow-Credentials: true` with a specific allowed origin.
        withCredentials: true,
      }),
    }),
  }),
});

export const { useRequestMagicLinkMutation } = authenticationApi;
